module.exports = __webpack_public_path__ + "static/berbalang-79da131895ab7408486584752f77b32b.png";